module.exports = __webpack_public_path__ + "img/weixin.aa45589c.png";